import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { NumItemsInReturnOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  numItemsInReturnFromModel,
  validateNumItemsInReturnCondition,
  type NumItemsInReturnState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const NUM_ITEMS_IN_RETURN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<NumItemsInReturnState>
  >,
): ConditionType<NumItemsInReturnState, Condition.NumItemsInReturn> => ({
  name: CONDITION_NAMES[Condition.NUM_ITEMS_IN_RETURN],
  description(state) {
    switch (state.numItemsOption) {
      case NumItemsInReturnOption.LESS_THAN:
        return t("Number of items in return less than {{value}}", {
          value: state.numItems,
        });
      case NumItemsInReturnOption.GREATER_THAN:
        return t("Number of items in return greater than {{value}}", {
          value: state.numItems,
        });
      case NumItemsInReturnOption.EQUALS:
        return t("Number of items in return equals {{value}}", {
          value: state.numItems,
        });
    }
  },
  Details(props: ConditionTypeDetailsProps<NumItemsInReturnState>) {
    return React.createElement(Details, props);
  },
  empty: { numItemsOption: NumItemsInReturnOption.EQUALS, numItems: "1" },
  fromModel(model) {
    return numItemsInReturnFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.NUM_ITEMS_IN_RETURN,
      numItemsOption: state.numItemsOption,
      numItems: +state.numItems,
    };
  },
  valid(state) {
    return validateNumItemsInReturnCondition(state).valid;
  },
});
